export default "__VITE_ASSET__DtLHqYa7__"